import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const AGB = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-medical-50 via-white to-medical-100">
      {/* Header */}
      <header className="border-b border-border/40 bg-background/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold text-primary">
            MediQR
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ChevronLeft className="mr-2 h-4 w-4" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-background/60 backdrop-blur-sm rounded-2xl shadow-lg p-8 md:p-12 border border-border/50">
          <h1 className="text-4xl font-bold text-foreground mb-6">
            Allgemeine Geschäftsbedingungen (AGB)
          </h1>
          
          <div className="space-y-8 text-muted-foreground">
            {/* § 1 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 1 Geltungsbereich, Vertragspartner
              </h2>
              <div className="space-y-3">
                <p>
                  Diese Allgemeinen Geschäftsbedingungen (im Folgenden: AGB) regeln das Vertragsverhältnis zwischen der 
                  DiekerIT (im Folgenden: Anbieter oder wir) und dem Kunden (im Folgenden: Kunde oder Sie) bezüglich der 
                  Nutzung der Applikation „MediQR" (im Folgenden: App oder MediQR).
                </p>
                <p>
                  Das Angebot richtet sich ausschließlich an Verbraucher (§ 13 BGB).
                </p>
                <p>
                  Abweichende oder ergänzende AGB des Kunden werden nicht Vertragsbestandteil.
                </p>
              </div>
            </section>

            {/* § 2 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 2 Vertragsgegenstand und Leistungsumfang
              </h2>
              <div className="space-y-3">
                <p>
                  Der Anbieter stellt dem Kunden über die MediQR-App eine Dienstleistung zur Generierung, Speicherung und 
                  Verwaltung eines digitalen Notfallprofils zur Verfügung.
                </p>
                <p className="font-medium text-foreground">
                  Der Hauptleistungsumfang umfasst insbesondere:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Die Erfassung und verschlüsselte Speicherung der vom Kunden bereitgestellten sensiblen medizinischen Informationen.</li>
                  <li>Die Generierung eines persönlichen QR-Codes, der auf das digitale Notfallprofil des Kunden verlinkt.</li>
                  <li>Die Bereitstellung des Notfallprofils zum jederzeitigen Abruf durch Dritte (insbesondere Rettungskräfte) mittels Scannen des QR-Codes.</li>
                </ul>
                <p>
                  Der konkrete Leistungsumfang ist abhängig vom gebuchten Tarif. Der Basistarif umfasst ein Profil.
                </p>
              </div>
            </section>

            {/* § 3 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 3 Hinweis zur Notfallfunktion und Haftungsausschluss
              </h2>
              <div className="space-y-3">
                <p className="font-medium text-foreground">
                  MediQR ist ein reines Informationshilfsmittel. Die App dient lediglich der Beschleunigung der 
                  Informationsweitergabe im Notfall und ersetzt keinesfalls eine professionelle notfallmedizinische Versorgung, 
                  eine medizinische Diagnose oder die Anwesenheit von qualifiziertem Rettungspersonal.
                </p>
                <p className="font-medium text-foreground">
                  Verantwortung für die Daten:
                </p>
                <p>
                  Der Kunde ist allein für die Richtigkeit, Vollständigkeit und Aktualität der in seinem Notfallprofil 
                  hinterlegten medizinischen Daten verantwortlich. Der Anbieter übernimmt keine Gewährleistung für die 
                  Korrektheit der Daten.
                </p>
                <p className="font-medium text-foreground">
                  Haftungsausschluss des Anbieters:
                </p>
                <p>
                  Die Haftung der DiekerIT für Schäden, die aus der Nutzung im Notfall entstehen, ist ausgeschlossen. 
                  Dies gilt insbesondere für Schäden, die dadurch entstehen, dass:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>die Daten im Notfall nicht abgerufen werden können (z. B. wegen fehlender Internetverbindung oder technischer Mängel außerhalb unseres Verantwortungsbereichs).</li>
                  <li>der QR-Code nicht gefunden, nicht gescannt oder nicht am vorgesehenen Ort platziert war.</li>
                  <li>Rettungskräfte die hinterlegten Informationen nicht berücksichtigen.</li>
                  <li>der Kunde es versäumt, die hinterlegten Daten rechtzeitig zu aktualisieren.</li>
                </ul>
                <p>
                  Die Haftung der DiekerIT für einfache Fahrlässigkeit wird ausgeschlossen, sofern keine Verletzung von 
                  Kardinalpflichten (wesentliche Vertragspflichten) vorliegt. Die gesetzliche Haftung für Schäden aus der 
                  Verletzung des Lebens, des Körpers oder der Gesundheit sowie nach dem Produkthaftungsgesetz bleibt unberührt.
                </p>
              </div>
            </section>

            {/* § 4 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 4 Vertragsschluss und Pflichten des Kunden
              </h2>
              <div className="space-y-3">
                <p>
                  Der Vertrag kommt durch die Annahmeerklärung der DiekerIT in Form einer Bestätigungs-E-Mail oder durch 
                  Freischaltung des kostenpflichtigen Tarifs zustande.
                </p>
                <p className="font-medium text-foreground">Zugangsdaten:</p>
                <p>Der Kunde ist verpflichtet, seine Zugangsdaten geheim zu halten.</p>
                <p className="font-medium text-foreground">Einwilligung Minderjährige:</p>
                <p>
                  Für die Erstellung und Verwaltung von Notfallprofilen für Minderjährige ist die ausdrückliche Einwilligung 
                  der gesetzlichen Vertreter erforderlich. Der Kunde sichert zu, dass er diese Einwilligung besitzt.
                </p>
              </div>
            </section>

            {/* § 5 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 5 Preise und Zahlungsbedingungen (Stripe)
              </h2>
              <div className="space-y-3">
                <p>
                  Es gelten die zum Zeitpunkt des Vertragsschlusses in der App angegebenen Preise. Alle Preise sind 
                  Endpreise. Gemäß § 19 UStG (Kleinunternehmerregelung) wird keine Umsatzsteuer berechnet und ausgewiesen.
                </p>
                <p>
                  Die Zahlung erfolgt im Voraus für die jeweils gebuchte Laufzeit über den Zahlungsdienstleister Stripe.
                </p>
              </div>
            </section>

            {/* § 6 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 6 Laufzeit, Verlängerung und Kündigung
              </h2>
              <div className="space-y-3">
                <p><strong className="text-foreground">Laufzeit:</strong> Das Abonnement hat eine feste Laufzeit von einem (1) Monat.</p>
                <p><strong className="text-foreground">Automatische Verlängerung:</strong> Das Abonnement verlängert sich automatisch um jeweils einen weiteren Monat, wenn es nicht fristgerecht gekündigt wird.</p>
                <p><strong className="text-foreground">Kündigungsfrist:</strong> Der Kunde kann das Abonnement jederzeit mit einer Frist von einem (1) Tag zum Ende der jeweiligen monatlichen Laufzeit kündigen.</p>
                <p><strong className="text-foreground">Kündigungsform:</strong> Die Kündigung kann über die in der App dafür vorgesehene Funktion oder in Textform erfolgen.</p>
                <p><strong className="text-foreground">Folge der Kündigung:</strong> Mit Wirksamwerden der Kündigung wird der kostenpflichtige Tarif auf den kostenlosen Basistarif umgestellt.</p>
                <p><strong className="text-foreground">Umgang mit Profilen nach Kündigung:</strong> Das erste und primäre Notfallprofil verbleibt im Rahmen des kostenlosen Basistarifs bestehen. Alle zusätzlichen Notfallprofile, die das Abonnement erforderten, werden unzugänglich gemacht, bleiben aber zunächst gespeichert.</p>
              </div>
            </section>

            {/* § 7 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 7 Löschung des Nutzerkontos und der Daten
              </h2>
              <div className="space-y-3">
                <p><strong className="text-foreground">Löschung des Kontos:</strong> Der Kunde kann die vollständige Löschung seines Nutzerkontos und aller damit verbundenen Daten jederzeit beantragen.</p>
                <p>
                  Der Antrag auf vollständige Löschung muss per E-Mail an{" "}
                  <a href="mailto:R.Dieker@DiekerIT.com" className="text-primary hover:underline">
                    R.Dieker@DiekerIT.com
                  </a>{" "}
                  gestellt werden.
                </p>
                <p>
                  Nach Kontolöschung werden alle gespeicherten personenbezogenen Daten, einschließlich aller Notfallprofile, 
                  unverzüglich gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                </p>
              </div>
            </section>

            {/* § 8 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 8 Widerrufsrecht für Verbraucher
              </h2>
              <div className="space-y-3">
                <p>
                  Als Verbraucher steht Ihnen grundsätzlich ein gesetzliches Widerrufsrecht zu.
                </p>
                
                <h3 className="text-xl font-semibold text-foreground mt-6">Widerrufsbelehrung</h3>
                
                <p className="font-medium text-foreground">Widerrufsrecht</p>
                <p>
                  Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. 
                  Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
                </p>
                <p>
                  Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (DiekerIT, Zum roten Berge 19, 48165 Münster, 
                  E-Mail: R.Dieker@DiekerIT.com) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter 
                  Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können 
                  dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
                </p>
                <p>
                  Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts 
                  vor Ablauf der Widerrufsfrist absenden.
                </p>
                
                <p className="font-medium text-foreground mt-4">Folgen des Widerrufs</p>
                <p>
                  Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, 
                  einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie 
                  eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), 
                  unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über 
                  Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe 
                  Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde 
                  ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
                </p>
                
                <p className="font-medium text-foreground mt-4">Besondere Hinweise zum Erlöschen des Widerrufsrechts</p>
                <p>
                  Ihr Widerrufsrecht erlischt bei einem Vertrag über die Lieferung von nicht auf einem körperlichen Datenträger 
                  befindlichen digitalen Inhalten (wie der Zugang zur App), wenn Sie ausdrücklich zugestimmt haben, dass wir 
                  mit der Ausführung des Vertrages vor Ablauf der Widerrufsfrist beginnen, und Sie Ihre Kenntnis davon bestätigt 
                  haben, dass Sie durch Ihre Zustimmung mit dem Beginn der Ausführung Ihr Widerrufsrecht verlieren.
                </p>
                <p className="text-sm italic">
                  (Diese Zustimmung wird technisch beim Bestellprozess abgefragt und muss dort protokolliert werden.)
                </p>
              </div>
            </section>

            {/* § 9 */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                § 9 Schlussbestimmungen
              </h2>
              <div className="space-y-3">
                <p>
                  Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                </p>
                <p>
                  Ist der Kunde Verbraucher, so ist der Gerichtsstand der Sitz des Kunden.
                </p>
                <p>
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so wird die Wirksamkeit der übrigen 
                  Bestimmungen hiervon nicht berührt.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border/40 bg-background/60 backdrop-blur-sm mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col items-center space-y-4">
            <div className="text-2xl font-bold text-primary">MediQR</div>
            <div className="flex gap-6 text-sm text-muted-foreground">
              <Link to="/impressum" className="hover:text-foreground transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-foreground transition-colors">
                Datenschutz
              </Link>
              <Link to="/agb" className="hover:text-foreground transition-colors">
                AGB
              </Link>
              <Link to="/widerrufsrecht" className="hover:text-foreground transition-colors">
                Widerrufsrecht
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AGB;
